import { FC, PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import styles from './photo-tile-base.style';

interface IProps extends PropsWithChildren {
  url: string;
}

// TODO: support multi photo with scrolling
export const PhotoTileBase: FC<IProps> = ({ url, children }) => (
  <Box style={styles.photo(url)}>{children}</Box>
);
